import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllroleEmployeesPageable } from '../../../../../reduxToolkit/EmployeeRoles/EmployeeRolesApi';
import TableFunction from './../../../../../components/table/TableFunction';
import { useTranslation } from 'react-i18next';
import { SEARCH_MODEL } from './../../../../../components/table/Model/TableModel';
import { getFullName } from '../../../../../Apis/functions';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const PrivilegeDetailsApp = (item) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [searchResults, setSearchResults] = useState('');
    const [selectedList, setSelectedList] = useState([]);
    const [modified, setModified] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [remove, setRemove] = useState('');
    const [searchElement, setSearchElement] = useState('');
    const [selected, setSelected] = useState([]);
    const [selectForDelete, setSelectForDelete] = useState([]);
    const [triggerDelete, setTriggerDelete] = useState(false);
    const [results, setResults] = useState([]);
    const [bodyForExport, setBodyForExport] = useState(null);
    const [search, setSearch] = useState('');
    const [simpleSearch, setSimpleSearch] = useState('');

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
         if (!item) return;
        const body = {
            id: item,
            key: searchElement,
            pagination: {
                page,
                size: rowsPerPage,
            },
        };

        dispatch(getAllroleEmployeesPageable(body)).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    };

    // Custom hook that handles table logic: pagination, selection, header and body
    const { pagination, rowsPerPage } = TableFunction({
        selectedList,
        setSelectedList,
        data: searchResults,
        labelRowsPerPage: 'employees_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        searchElement,
        getData, //New
        modified, //New
        setModified, //New
    });

    // Syncs selected list based on the "select all" checkbox state
    useEffect(() => {
        if (isAllChecked && searchResults?.content?.length > 0) {
            const allIds = searchResults.content.map((item) => item?.userId);
            setSelectedList(allIds);
        } else if (!isAllChecked) {
            setSelectedList([]);
        }
    }, [isAllChecked, searchResults]);

    return {
        searchResults,
        remove,
        setRemove,
        t,
        pagination,
        searchElement,
        setSearchElement,
        selected,
        setSelected,
        selectForDelete,
        setSelectForDelete,
        isAllChecked,
        setIsAllChecked,
        triggerDelete,
        setTriggerDelete,
        results: searchResults,
        setResults: setSearchResults,
        setBodyForExport,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
    };
};

export default PrivilegeDetailsApp;
